/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
import{isNone as r}from"../../../../core/maybe.js";function e(e){return r(e)?e:e.slice()}function n(r){return[r,r]}export{e as createStipplePattern,n as createStipplePatternSimple};
